var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappTemplateVisitWebsiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.616,
    height: 21.616,
    viewBox: "0 0 21.616 21.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "external-link",
    d: "M15.652,5.275a1.138,1.138,0,1,1,0-2.275h6.826a1.138,1.138,0,0,1,1.138,1.138v6.826a1.138,1.138,0,1,1-2.275,0V6.884l-8.3,8.3a1.138,1.138,0,1,1-1.609-1.609l8.3-8.3ZM5.413,7.551A1.138,1.138,0,0,0,4.275,8.689V21.2a1.138,1.138,0,0,0,1.138,1.138H17.928A1.138,1.138,0,0,0,19.066,21.2V16.012a1.138,1.138,0,0,1,2.275,0V21.2a3.413,3.413,0,0,1-3.413,3.413H5.413A3.413,3.413,0,0,1,2,21.2V8.689A3.413,3.413,0,0,1,5.413,5.275H10.6a1.138,1.138,0,1,1,0,2.275Z",
    transform: "translate(-2 -3)",
    fill: "#00a5f4",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappTemplateVisitWebsiteIcon);
export default __webpack_public_path__ + "static/media/whatsapp-template-visit-website-icon.c7504ef3ed404f6e144192e4cd815807.svg";
export { ForwardRef as ReactComponent };